
<app-navbar-style-two></app-navbar-style-two>



<!-- Catering Introduction -->
<!-- ===========================
        HERO SECTION
============================ -->

<section class="catering-hero">

    <div class="hero-overlay"></div>

    <div class="container">

        <div class="hero-content">

            <span class="hero-tag">
                Premium Catering Services
            </span>

            <h1>
                Delicious Food.<br>
                Memorable Celebrations.
            </h1>

            <p>
                From intimate family gatherings to luxurious weddings and corporate
                events, Kitchen Magic creates extraordinary catering experiences
                with authentic flavors and impeccable hospitality.
            </p>

            <div class="hero-buttons">

                <a routerLink="/contact" class="btn-book">
                    Book Catering
                </a>

                <a href="tel:+1 (669) 871-0461" class="btn-call">
                    Call Now
                </a>

                <button class="btn-download-menu" (click)="downloadMenu()">
                    <i class='bx bx-download'></i>
                    Download Menu
                </button>

            </div>

        </div>

    </div>

</section>

<section class="events-section">

<div class="container">

<div class="section-title">

<span>OUR SERVICES</span>

<h2>Catering For Every Occasion</h2>

<p>
Whether you're hosting 20 guests or 2000,
Kitchen Magic delivers exceptional food and service.
</p>

</div>

<div class="events-grid">

<div class="event-card">

<div class="event-image">

<img src="assets/img/wedding.png">

</div>

<div class="event-content">

<i class="bx bxs-heart"></i>

<h3>Wedding Catering</h3>

<p>

Traditional feast, buffet, live counters and
luxury wedding catering.

</p>

</div>

</div>

<div class="event-card">

<div class="event-image">

<img src="assets/img/birthday.png">

</div>

<div class="event-content">

<i class="bx bxs-cake"></i>

<h3>Birthday Parties</h3>

<p>

Celebrate birthdays with delicious menus,
desserts and live food stations.

</p>

</div>

</div>

<div class="event-card">

<div class="event-image">

<img src="assets/img/office.png">

</div>

<div class="event-content">

<i class="bx bxs-business"></i>

<h3>Corporate Events</h3>

<p>

Meetings, conferences,
product launches and office celebrations.

</p>

</div>

</div>

<div class="event-card">

<div class="event-image">

<img src="assets/img/familyfunction.png">

</div>

<div class="event-content">

<i class="bx bxs-home-heart"></i>

<h3>Family Functions</h3>

<p>

Housewarming,
baby shower,
engagement
and festive celebrations.

</p>

</div>

</div>

</div>

</div>

</section>
